import { render, staticRenderFns } from "./relatives-list.vue?vue&type=template&id=623d148d&scoped=true"
import script from "./relatives-list.vue?vue&type=script&lang=js"
export * from "./relatives-list.vue?vue&type=script&lang=js"
import style0 from "./relatives-list.vue?vue&type=style&index=0&id=623d148d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d148d",
  null
  
)

export default component.exports